import { LUDUM_INTENSITIES, LUDUM_SPORTS } from '@/constants';
import {
    ROUTES_EVENT_ATTENDANCE,
    ROUTES_EVENT_OVERVIEW,
    ROUTES_SESSION_ATTENDANCE,
    ROUTES_SESSION_OVERVIEW
} from '@/constants/routes';
import { i18n } from '@/lang';

export function sessionOverviewRouteName(isSession) {
    return isSession ? ROUTES_SESSION_OVERVIEW : ROUTES_EVENT_OVERVIEW;
}

export function sessionAttendanceRouteName(isSession) {
    return isSession ? ROUTES_SESSION_ATTENDANCE : ROUTES_EVENT_ATTENDANCE;
}

export function intensityClass(intensityId) {
    switch (Number(intensityId)) {
        case LUDUM_INTENSITIES.UT1:
            return 'ut1';
        case LUDUM_INTENSITIES.UT2:
            return 'ut2';
        case LUDUM_INTENSITIES.UT3:
            return 'ut3';
        case LUDUM_INTENSITIES.AT:
            return 'at';
        case LUDUM_INTENSITIES.TR:
            return 'tr';
        case LUDUM_INTENSITIES.LACTATE_TOLERANCE:
            return 'lt';
        case LUDUM_INTENSITIES.A_LACT:
            return 'a-lact';
        default:
            return '';
    }
}

export function sportIconClass(sportId = null) {
    switch (sportId) {
        case LUDUM_SPORTS.ROWING:
            return 'icon-rowing';
        case LUDUM_SPORTS.PADDLING:
        case LUDUM_SPORTS.PADDLING_FLAT_WATER:
        case LUDUM_SPORTS.PADDLING_RESISTED:
        case LUDUM_SPORTS.PADDLING_WHITE_WATER:
        case LUDUM_SPORTS.PADDLING_WILD_WATER:
        case LUDUM_SPORTS.PADDLING_OCEAN:
        case LUDUM_SPORTS.KAYAK_CROSS:
            return 'icon-paddling';
        case LUDUM_SPORTS.ERGO:
            return 'icon-ergo';
        case LUDUM_SPORTS.INDOOR_CYCLING:
            return 'icon-indoor-cycling';
        case LUDUM_SPORTS.INDOOR_PADDLING:
            return 'icon-indoor-paddling';
        case LUDUM_SPORTS.INDOOR_SKIING:
            return 'icon-indoor-skiing';
        case LUDUM_SPORTS.VIRTUAL_RIDE:
            return 'icon-virtual-ride';
        case LUDUM_SPORTS.ELLIPTICAL:
            return 'icon-elliptical';
        case LUDUM_SPORTS.CROSS_TRAINER:
            return 'icon-cross-trainer';
        case LUDUM_SPORTS.SC:
            return 'icon-sc';
        case LUDUM_SPORTS.LES_MILLS_GRIT_CARDIO:
            return 'icon-les-mills-grit-cardio';
        case LUDUM_SPORTS.CIRCUIT:
            return 'icon-circuit';
        case LUDUM_SPORTS.FLEXIBILITY:
            return 'icon-flexibility';
        case LUDUM_SPORTS.CROSS_FIT:
            return 'icon-cross-fit';
        case LUDUM_SPORTS.DAY_OFF:
            return 'icon-day-off';
        case LUDUM_SPORTS.BIKE:
            return 'icon-bike';
        case LUDUM_SPORTS.MOUNTAIN_BIKING:
            return 'icon-mountain-biking';
        case LUDUM_SPORTS.WHEELCHAIR_RACING:
            return 'icon-wheelchair-racing';
        case LUDUM_SPORTS.HAND_CYCLING:
            return 'icon-hand-cycling';
        case LUDUM_SPORTS.RUN:
            return 'icon-run';
        case LUDUM_SPORTS.TRACK_AND_FIELD_RUNNING:
            return 'icon-track-field-running';
        case LUDUM_SPORTS.ALPINE_SKIING:
            return 'icon-alpine-skiing';
        case LUDUM_SPORTS.CROSS_COUNTRY_SKIING:
            return 'icon-cross-country-skiing';
        case LUDUM_SPORTS.SWIM:
            return 'icon-swim';
        case LUDUM_SPORTS.LAP_SWIMMING:
            return 'icon-lap-swimming';
        case LUDUM_SPORTS.STAND_UP_PADDLE:
            return 'icon-stand-up-paddle';
        case LUDUM_SPORTS.OTHER:
            return 'icon-other';
        case LUDUM_SPORTS.INDOOR_RUNNING:
            return 'icon-indoor-running';
        case LUDUM_SPORTS.BASKETBALL:
            return 'icon-basketball';
        case LUDUM_SPORTS.CAMOGIE:
        case LUDUM_SPORTS.HURLING:
            return 'icon-camogie-hurling';
        case LUDUM_SPORTS.FIELD_HOCKEY:
            return 'icon-field-hockey';
        case LUDUM_SPORTS.FOOTBALL:
            return 'icon-football';
        case LUDUM_SPORTS.GAELIC_FOOTBALL:
            return 'icon-gaelic-football';
        case LUDUM_SPORTS.HAND_BALL:
            return 'icon-handball';
        case LUDUM_SPORTS.HIKING:
            return 'icon-hiking';
        case LUDUM_SPORTS.ICE_HOCKEY:
            return 'icon-ice-hockey';
        case LUDUM_SPORTS.LACROSSE:
            return 'icon-lacrosse';
        case LUDUM_SPORTS.NETBALL:
            return 'icon-netball';
        case LUDUM_SPORTS.RACQUETBALL:
            return 'icon-racquetball';
        case LUDUM_SPORTS.RUGBY:
            return 'icon-rugby';
        case LUDUM_SPORTS.SPINNING:
            return 'icon-spinning';
        case LUDUM_SPORTS.SQUASH:
            return 'icon-squash';
        case LUDUM_SPORTS.TENNIS:
            return 'icon-tennis';
        case LUDUM_SPORTS.WALKING:
            return 'icon-walking';
        case LUDUM_SPORTS.CLIMBING:
            return 'icon-climbing';
        default:
            return 'icon-event';
    }
}

export function isBikeRelatedSession(sportId) {
    return [
        LUDUM_SPORTS.BIKE,
        LUDUM_SPORTS.MOUNTAIN_BIKING,
        LUDUM_SPORTS.WHEELCHAIR_RACING,
        LUDUM_SPORTS.HAND_CYCLING
    ].includes(Number(sportId));
}

export function isErgoSession(sportId) {
    return Number(sportId) === LUDUM_SPORTS.ERGO;
}

export function isIndoorSkiingSession(sportId) {
    return Number(sportId) === LUDUM_SPORTS.INDOOR_SKIING;
}

export function isIndoorPaddlingSession(sportId) {
    return Number(sportId) === LUDUM_SPORTS.INDOOR_PADDLING;
}

export function isErgoRelatedSession(sportId) {
    return [
        LUDUM_SPORTS.ERGO,
        LUDUM_SPORTS.INDOOR_PADDLING,
        LUDUM_SPORTS.INDOOR_SKIING,
        LUDUM_SPORTS.CROSS_TRAINER
    ].includes(Number(sportId));
}

export function isIndoorCyclingRelatedSession(sportId) {
    return [
        LUDUM_SPORTS.INDOOR_CYCLING,
        LUDUM_SPORTS.VIRTUAL_RIDE,
        LUDUM_SPORTS.ELLIPTICAL,
        LUDUM_SPORTS.SPINNING
    ].includes(Number(sportId));
}

export function isRunRelatedSession(sportId) {
    return [
        LUDUM_SPORTS.RUN,
        LUDUM_SPORTS.TRACK_AND_FIELD_RUNNING,
        LUDUM_SPORTS.ALPINE_SKIING,
        LUDUM_SPORTS.CROSS_COUNTRY_SKIING,
        LUDUM_SPORTS.HIKING,
        LUDUM_SPORTS.WALKING,
        LUDUM_SPORTS.INDOOR_RUNNING
    ].includes(Number(sportId));
}

export function isScSession(sportId) {
    return Number(sportId) === LUDUM_SPORTS.SC;
}

export function isScRelatedSession(sportId) {
    return [
        LUDUM_SPORTS.SC,
        LUDUM_SPORTS.LES_MILLS_GRIT_CARDIO,
        LUDUM_SPORTS.CIRCUIT,
        LUDUM_SPORTS.FLEXIBILITY,
        LUDUM_SPORTS.CROSS_FIT
    ].includes(Number(sportId));
}

export function isSwimRelatedSession(sportId) {
    return [LUDUM_SPORTS.SWIM, LUDUM_SPORTS.LAP_SWIMMING, LUDUM_SPORTS.STAND_UP_PADDLE].includes(Number(sportId));
}

export function isWaterSession(sportId) {
    return isRowingSession(sportId) || isPaddlingSession(sportId);
}

export function isRowingSession(sportId) {
    return Number(sportId) === LUDUM_SPORTS.ROWING;
}

export function isPaddlingSession(sportId) {
    return [
        LUDUM_SPORTS.PADDLING,
        LUDUM_SPORTS.PADDLING_FLAT_WATER,
        LUDUM_SPORTS.PADDLING_RESISTED,
        LUDUM_SPORTS.PADDLING_WHITE_WATER,
        LUDUM_SPORTS.PADDLING_WILD_WATER,
        LUDUM_SPORTS.PADDLING_OCEAN,
        LUDUM_SPORTS.KAYAK_CROSS
    ].includes(Number(sportId));
}

export function isPaddlingFlatWater(sportId) {
    return Number(sportId) === LUDUM_SPORTS.PADDLING_FLAT_WATER;
}

export function isMultisportSession(sportId) {
    return Number(sportId) === LUDUM_SPORTS.MULTISPORT;
}

export function isDayOffSession(sportId) {
    return Number(sportId) === LUDUM_SPORTS.DAY_OFF;
}

export function isStandUpPaddleSession(sportId) {
    return Number(sportId) === LUDUM_SPORTS.STAND_UP_PADDLE;
}

export function isOtherRelatedSession(sportId) {
    return [
        LUDUM_SPORTS.OTHER,
        LUDUM_SPORTS.BASKETBALL,
        LUDUM_SPORTS.CAMOGIE,
        LUDUM_SPORTS.FIELD_HOCKEY,
        LUDUM_SPORTS.FOOTBALL,
        LUDUM_SPORTS.GAELIC_FOOTBALL,
        LUDUM_SPORTS.HAND_BALL,
        LUDUM_SPORTS.HURLING,
        LUDUM_SPORTS.ICE_HOCKEY,
        LUDUM_SPORTS.LACROSSE,
        LUDUM_SPORTS.NETBALL,
        LUDUM_SPORTS.RACQUETBALL,
        LUDUM_SPORTS.RUGBY,
        LUDUM_SPORTS.SQUASH,
        LUDUM_SPORTS.TENNIS,
        LUDUM_SPORTS.CLIMBING
    ].includes(Number(sportId));
}

export function getSportGroup(sportId) {
    if ([
        LUDUM_SPORTS.ALPINE_SKIING,
        LUDUM_SPORTS.PADDLING,
        LUDUM_SPORTS.PADDLING_FLAT_WATER,
        LUDUM_SPORTS.PADDLING_RESISTED,
        LUDUM_SPORTS.PADDLING_WHITE_WATER,
        LUDUM_SPORTS.PADDLING_WILD_WATER,
        LUDUM_SPORTS.PADDLING_OCEAN,
        LUDUM_SPORTS.KAYAK_CROSS,
        LUDUM_SPORTS.CROSS_TRAINER,
        LUDUM_SPORTS.CROSS_COUNTRY_SKIING,
        LUDUM_SPORTS.ELLIPTICAL,
        LUDUM_SPORTS.HAND_CYCLING,
        LUDUM_SPORTS.HIKING,
        LUDUM_SPORTS.INDOOR_PADDLING,
        LUDUM_SPORTS.INDOOR_CYCLING,
        LUDUM_SPORTS.INDOOR_SKIING,
        LUDUM_SPORTS.INDOOR_RUNNING,
        LUDUM_SPORTS.WALKING,
        LUDUM_SPORTS.LAP_SWIMMING,
        LUDUM_SPORTS.MOUNTAIN_BIKING,
        LUDUM_SPORTS.SWIM,
        LUDUM_SPORTS.BIKE,
        LUDUM_SPORTS.RUN,
        LUDUM_SPORTS.SPINNING,
        LUDUM_SPORTS.STAND_UP_PADDLE,
        LUDUM_SPORTS.TRACK_AND_FIELD_RUNNING,
        LUDUM_SPORTS.VIRTUAL_RIDE,
        LUDUM_SPORTS.WHEELCHAIR_RACING,
        LUDUM_SPORTS.CLIMBING

    ].includes(Number(sportId))) {
        return i18n.t('nonSpecificEndurance')
    }

    if ([
        LUDUM_SPORTS.BASKETBALL,
        LUDUM_SPORTS.CAMOGIE,
        LUDUM_SPORTS.FIELD_HOCKEY,
        LUDUM_SPORTS.FLEXIBILITY,
        LUDUM_SPORTS.FOOTBALL,
        LUDUM_SPORTS.GAELIC_FOOTBALL,
        LUDUM_SPORTS.HAND_BALL,
        LUDUM_SPORTS.HURLING,
        LUDUM_SPORTS.ICE_HOCKEY,
        LUDUM_SPORTS.LACROSSE,
        LUDUM_SPORTS.NETBALL,
        LUDUM_SPORTS.OTHER,
        LUDUM_SPORTS.RACQUETBALL,
        LUDUM_SPORTS.RUGBY,
        LUDUM_SPORTS.SQUASH,
        LUDUM_SPORTS.TENNIS

    ].includes(Number(sportId))) {
        return i18n.t('other')
    }

    if ([
        LUDUM_SPORTS.CIRCUIT,
        LUDUM_SPORTS.CROSS_FIT,
        LUDUM_SPORTS.SC,
    ].includes(Number(sportId))) {
        return i18n.t('sc')
    }

    if ([
        LUDUM_SPORTS.ERGO,
        LUDUM_SPORTS.ROWING
    ].includes(Number(sportId))) {
        return i18n.t('specificEndurance')
    }

    if ([
        LUDUM_SPORTS.DAY_OFF,
    ].includes(Number(sportId))) {
        return i18n.t('noTraining')
    }

    return '';
}

export function isNonSpecificEnduranceSportGroup(sportId) {
    return [
        LUDUM_SPORTS.ALPINE_SKIING,
        LUDUM_SPORTS.PADDLING,
        LUDUM_SPORTS.PADDLING_FLAT_WATER,
        LUDUM_SPORTS.PADDLING_RESISTED,
        LUDUM_SPORTS.PADDLING_WHITE_WATER,
        LUDUM_SPORTS.PADDLING_WILD_WATER,
        LUDUM_SPORTS.PADDLING_OCEAN,
        LUDUM_SPORTS.KAYAK_CROSS,
        LUDUM_SPORTS.CROSS_TRAINER,
        LUDUM_SPORTS.CROSS_COUNTRY_SKIING,
        LUDUM_SPORTS.ELLIPTICAL,
        LUDUM_SPORTS.HAND_CYCLING,
        LUDUM_SPORTS.HIKING,
        LUDUM_SPORTS.INDOOR_PADDLING,
        LUDUM_SPORTS.INDOOR_CYCLING,
        LUDUM_SPORTS.INDOOR_SKIING,
        LUDUM_SPORTS.INDOOR_RUNNING,
        LUDUM_SPORTS.WALKING,
        LUDUM_SPORTS.LAP_SWIMMING,
        LUDUM_SPORTS.MOUNTAIN_BIKING,
        LUDUM_SPORTS.SWIM,
        LUDUM_SPORTS.BIKE,
        LUDUM_SPORTS.RUN,
        LUDUM_SPORTS.SPINNING,
        LUDUM_SPORTS.STAND_UP_PADDLE,
        LUDUM_SPORTS.TRACK_AND_FIELD_RUNNING,
        LUDUM_SPORTS.VIRTUAL_RIDE,
        LUDUM_SPORTS.WHEELCHAIR_RACING,
        LUDUM_SPORTS.CLIMBING
    ].includes(Number(sportId));
}

export function isOtherSportGroup(sportId) {
    return [
        LUDUM_SPORTS.BASKETBALL,
        LUDUM_SPORTS.CAMOGIE,
        LUDUM_SPORTS.FIELD_HOCKEY,
        LUDUM_SPORTS.FLEXIBILITY,
        LUDUM_SPORTS.FOOTBALL,
        LUDUM_SPORTS.GAELIC_FOOTBALL,
        LUDUM_SPORTS.HAND_BALL,
        LUDUM_SPORTS.HURLING,
        LUDUM_SPORTS.ICE_HOCKEY,
        LUDUM_SPORTS.LACROSSE,
        LUDUM_SPORTS.NETBALL,
        LUDUM_SPORTS.OTHER,
        LUDUM_SPORTS.RACQUETBALL,
        LUDUM_SPORTS.RUGBY,
        LUDUM_SPORTS.SQUASH,
        LUDUM_SPORTS.TENNIS

    ].includes(Number(sportId));
}

export function isSCSportGroup(sportId) {
    return [
        LUDUM_SPORTS.CIRCUIT,
        LUDUM_SPORTS.CROSS_FIT,
        LUDUM_SPORTS.SC,
    ].includes(Number(sportId));
}

export function isSpecificEnduranceSportGroup(sportId) {
    return [
        LUDUM_SPORTS.ERGO,
        LUDUM_SPORTS.ROWING
    ].includes(Number(sportId));
}

export const SPECIFIC_ENDURANCE_SPORT_GROUP = 1;
export const NON_SPECIFIC_ENDURANCE_SPORT_GROUP = 2;
export const SC_SPORT_GROUP = 3;
export const OTHER_SPORT_GROUP = 4;

export function getAllSportGroups() {
    return [
        { id: SPECIFIC_ENDURANCE_SPORT_GROUP, name: i18n.t('nonSpecificEnduranceShort') },
        { id: NON_SPECIFIC_ENDURANCE_SPORT_GROUP, name: i18n.t('specificEnduranceShort') },
        { id: SC_SPORT_GROUP, name: i18n.t('sc') },
        { id: OTHER_SPORT_GROUP, name: i18n.t('other') }
    ];
}
